module.exports = __webpack_public_path__ + "img/evaluate_logo.c766f235.png";